import { REACTION } from '~/modules/reactions/types';

export type PlagiarismScanFeedbackValue = 'like' | 'dislike';

export type PlagiarismScanFeedback = {
  value: PlagiarismScanFeedbackValue;
  created_at?: string;
  updated_at?: string;
};

export const mapReactionToPlagiarismScanFeedbackValue = (
  reaction: REACTION,
): PlagiarismScanFeedbackValue | null => {
  if (reaction === REACTION.LIKE) {
    return 'like';
  }

  if (reaction === REACTION.DISLIKE) {
    return 'dislike';
  }

  return null;
};

export const mapPlagiarismScanFeedbackToReaction = (
  feedback?: PlagiarismScanFeedback | null,
): REACTION => {
  if (!feedback?.value) {
    return REACTION.NONE;
  }

  if (feedback.value === 'like') {
    return REACTION.LIKE;
  }

  if (feedback.value === 'dislike') {
    return REACTION.DISLIKE;
  }

  return REACTION.NONE;
};
